import { SettingConst } from '../../types';

/**
 * Lazy load signup routes to reduce intial signup load latency
 */
export const LAZY_LOAD_SIGNUP_ROUTES_250122 =
  'LAZY_LOAD_SIGNUP_ROUTES_250122' as SettingConst<
    'LAZY_LOAD_SIGNUP_ROUTES_250122',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER'
  >;
